import React from "react";
// import { Phone } from "lucide-react";

const ContactHelp = () => {
  return (
    <div className="bg-white shadow-lg rounded-lg p-4 flex flex-col items-center text-center border border-gray-200">
      <h3 className="text-xl font-semibold text-gray-800">Got a Question?</h3>
      <p className="text-gray-600 mt-2">
        Our Support Team will be happy to help you resolve your queries for this tour.
      </p>
      <div className="flex items-center mt-4 space-x-2 text-lg text-black font-semibold">
        {/* <Phone className="w-6 h-6 text-blue-500" /> */}
        <a href="tel:+919773346418" className="hover:text-blue-600">
          +91 97733 46418
        </a>
      </div>
      <p className="text-gray-500 mt-2 text-sm">10:30 AM - 8:00 PM (Mon to Sat)</p>
    </div>
  );
};

export default ContactHelp;
